import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QuickFilterKey, QuickFilterType } from '../../enums/quick-filter.enum';

export interface QuickFilterChip {
  key: QuickFilterKey;
  label: string;
  icon: string;
}

/* Reusable chips row (Community Verified, Top Contributors, Following, Newest).
   It does not filter any data itself, it only tracks the selected chips and emits them to the parent.
 */
@Component({
  selector: 'app-quick-filters',
  templateUrl: './quick-filters.component.html',
  styleUrls: ['./quick-filters.component.scss'],
  standalone: false
})
export class QuickFiltersComponent {

  @Input() disabled: boolean = false; // Set by the parent while the list is loading, so no other filter can be selected until it is done.
  @Input() selectedFilters: QuickFilterKey[] = [];

    // Emits the updated list of selected filters every time a chip is clicked.
  @Output() selectedFiltersChange: EventEmitter<QuickFilterKey[]> = new EventEmitter<QuickFilterKey[]>();

  filters: QuickFilterChip[] = (Object.keys(QuickFilterType) as QuickFilterKey[]).map((key: QuickFilterKey) => ({
    key,
    label: QuickFilterType[key],
    icon: `./assets/images/quick-filter-${key.toLowerCase().replace(/_/g, '-')}.svg`
  }));

  /**
   * Checks if a given filter is currently selected to highlight the chip.
   * @param filter The filter to check.
   */ 
  isSelected(filter: QuickFilterKey): boolean {
    return this.selectedFilters.includes(filter);
  }

    /**
   * Method to toggle the selection state of a filter chip.
   * Adds the selected filter to the selection if it is not selected, otherwise removes it.
   * @param filter The filter chip to toggle.
   */
  toggleFilter(filter: QuickFilterKey) {
    if (this.disabled) {
      return;
    }
    let updatedFilters: QuickFilterKey[];

    if (this.isSelected(filter)) {
// If the filter was already selected, remove it from the selection.
      updatedFilters = this.selectedFilters.filter((selected: QuickFilterKey) => selected !== filter);
    } else {
            // If the filter was not selected before, add this to updated filters array.
      updatedFilters = [...this.selectedFilters, filter];
    }
    this.selectedFilters = updatedFilters;
    this.selectedFiltersChange.emit(updatedFilters);
  }
}
